document.addEventListener("DOMContentLoaded", function(){
  $(document).on("change", "select[name='schedule_workday_replacement[employee_id]'], select[name='schedule_workday_replacement[period_id]']", function(){
    $("#schedule-workday-replacement-modal-content").removeAttr('noreload')
    $("#schedule-workday-replacement-form-table").find("tbody").html("")
  })

  $(document).on("click", "#schedule-workday-replacement-modal-trigger", function(){
    const $employee_id = $("select[name='schedule_workday_replacement[employee_id]'")
    const $period_id = $("select[name='schedule_workday_replacement[period_id]'")

    if (!($employee_id.val() && $period_id.val())){
      alert("Error: Please select employee and period!")
      return false
    }

    if ($("#schedule-workday-replacement-modal-content").attr("noreload") == undefined){
      loadModal({
        title: 'Select Date to Replace',
        url: `/schedule/workday_replacements/partial?employee_id=${$employee_id.val()}&period_id=${$period_id.val()}`
      })
    } else {
      modal.show()
    }
  })

  $(document).on("click", "#schedule-workday-replacement-modal-select", function(){
    const $selected = $("input[name='test-check']:checked")

    if ($selected.length == 0) {
      alert("Please select a date (minimal 1) to replace")
      return false
    }

    const ewc_ids = []
    $("input[name='test-check']:checked").each(function(idx, elm){
      ewc_ids.push($(elm).val())
    })
  
    $.ajax({
      url: "/schedule/workday_replacements/partial",
      data: { 
        ewc_ids: ewc_ids,
        period_id: $("#schedule-workday-replacement-modal-content").attr("pid"),
        employee_id: $("#schedule-workday-replacement-modal-content").attr("eid")
      },
      dataType: "script",
      beforeSend: function(){
        $("#schedule-workday-replacement-modal-select").attr('disabled', 'disabled')
      },
      success: function(res){
        $("#schedule-workday-replacement-form-table").find("tbody").html(res)
        modal.hide()
        initializeOnlyEnableDateFlatPickr()
      },
      error: function(jqXHR) {
        alert("Something error, call IT!")
      },
      complete: function(){
        $("#schedule-workday-replacement-modal-select").removeAttr('disabled')
      }
    })
  })
})